import BasePage from '../../components/base-page/base-page';
import VideoModal from '../../components/video-modal/video-modal';
import Switcher from '../../components/switcher/switcher';

import './how-it-works.scss';

class HowItWorksPage extends BasePage {
  uiCollections = {
    switchers: '.switcher',
  };

  onInit() {
    super.onInit();

    this.initSwitchers();
    new VideoModal().init();
  }

  initSwitchers() {
    this.uiCollections.switchers.forEach((switcherEl) => {
      new Switcher({ rootElement: switcherEl }).init();
    });
  }
}

export default HowItWorksPage;

HowItWorksPage.initOnDomLoaded();
